import React from 'react';
import VendorPreviewModal from '../../components/modals/VendorPreviewModal/VendorPreviewModal';

const VendorPreview = () => <VendorPreviewModal />;

export default VendorPreview;
